import styled from "styled-components";
import { ACCENT_PRIMARY_LIGHTEST } from "@streeteasy/design-system/colors";

export const ConfirmationTextContainer = styled.span`
  background-color: ${ACCENT_PRIMARY_LIGHTEST};
  display: block;
  padding: 24px;
`;
